import { create } from 'zustand'

import type { Entity } from '../types/entity.type'

export type MainStoreState = {
  isCustomerStartedOrder: boolean
  customers: Entity[] | undefined
  initialLocationForOrder: string | undefined
  loadingMessage: string
  selectedDate?: Date
  isLoading: boolean
  // Novo estado para o progresso
  progress: {
    current: number
    total: number
    percentage: number
  }
  confirmation: {
    isOpen: boolean
    title?: string
    timeout?: number
    message?: string
    onClose?: () => void
    onConfirm?: () => void
  }
}

export type MainStoreAction = {
  actions: {
    setLoadingMessage: (props: string) => void
    setIsLoading: (props: boolean) => void
    setSelectedDate: (props: Date | undefined) => void
    setIsCustomerStartedOrder: (props: boolean) => void
    setCustomers: (clients: Entity[] | undefined) => void
    setInitialLocationForOrder: (props: string | undefined) => void
    // Novas ações para o progresso
    setProgress: (current: number, total: number) => void
    resetProgress: () => void
    setConfirmation: (props: {
      isOpen: boolean
      title?: string
      timeout?: number
      message?: string
      onClose?: () => void
      onConfirm?: () => void
    }) => void
    setCloseConfirmation: () => void
  }
}

export const useMainStore = create<MainStoreState & MainStoreAction>((set) => ({
  customers: undefined,
  isCustomerStartedOrder: false,
  selectedDate: undefined,
  initialLocationForOrder: undefined,
  loadingMessage: 'Carregando, por favor aguarde...',
  isLoading: false,
  // Estado inicial do progresso
  progress: {
    current: 0,
    total: 0,
    percentage: 0
  },
  confirmation: {
    isOpen: false,
    title: '',
    timeout: undefined,
    message: '',
    onClose: () => {},
    onConfirm: () => {},
  },

  actions: {
    setSelectedDate: (props) => set({ selectedDate: props }),
    setLoadingMessage: (props) => set({ loadingMessage: props }),
    setIsLoading: (props) => set({ isLoading: props }),
    setCustomers: (customers) => set({ customers }),
    setIsCustomerStartedOrder: (props) =>
      set({ isCustomerStartedOrder: props }),
    setInitialLocationForOrder: (props) =>
      set({ initialLocationForOrder: props }),
    // Novas ações para gerenciar o progresso
    setProgress: (current, total) => set({
      progress: {
        current,
        total,
        percentage: total > 0 ? Math.round((current / total) * 100) : 0
      }
    }),
    resetProgress: () => set({
      progress: {
        current: 0,
        total: 0,
        percentage: 0
      }
    }),
    setConfirmation: (props) => set({ confirmation: { ...props } }),
    setCloseConfirmation: () =>
      set({
        confirmation: {
          isOpen: false,
          title: '',
          message: '',
          onClose: () => {},
          onConfirm: () => {},
        },
      }),
  },
}))